<template>
    <div style="height: 100%;">
        <div style="height: 90%; border: 1px solid #ccc; margin: 10px;">
            <div v-show="showpage === 'input'" style="position: relative; height: 100%;">
                <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%;">
                    <span>{{ resTypeName }}：</span>
                    <el-input v-model="resLink" :placeholder="linkInputPlaceholder" style="width: 40%;"></el-input>
                    <el-button @click="btnRunLinkAudit">执行审核</el-button>
                    <span>或</span>
                    <el-upload style="display: inline-block;" :show-file-list="false" :http-request="btnUploadFile" v-loading="fileUploadLoading" :accept="uploadAcceptType" action="/cmsMateService/servlet/UploadFile">
                        <el-button>文件上传</el-button>
                    </el-upload>
                    <div style="font-size: 12px; color: #8c8c8c; margin-top: 10px;">
                        <span v-if="this.resType === 1">图片支持格式：jpg、jpeg、png、gif、bmp、webp，支持大小&lt;8M</span>
                        <span v-else-if="this.resType === 2">视频支持格式: avi, mov, mp4, 3gp, rmvb, wmv, flv, m3u8，支持时长&lt;2小时，支持大小&lt;100M</span>
                        <span v-else-if="this.resType === 3">音频支持格式：mp3, wav, wma</span>
                    </div>
                </div>
            </div>
            <div v-show="showpage === 'result'" style="height: 100%;">
                <el-row style="display: flex; height: 100%;" align="middle">
                    <el-col :span="12" style="border: 1px solid #ccc; position: relative;">
                        <img v-if="resType === 1" :src="resultInfo.link" alt="" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;">
                        <video v-else :src="resultInfo.link" controls="controls" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;"></video>
                        <!-- <audio v-else controls="controls" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); max-width: 90%; max-height: 90%;">
                            <source :src="resultInfo.link" type="audio/mp3">
                        </audio> -->
                    </el-col>
                    <el-col :span="12" style="border: 1px solid #ccc; padding: 10px; overflow-y: scroll;">
                        <div v-if="resultInfo.auditStatus === 0 || resultInfo.auditStatus === 1">
                            <div class="loader loader--spinningDisc"></div>
                            <div style="font-size: 27px;">
                                <span v-if="resultInfo.resultCheckTimes < 10 || true">审核中......</span>
                                <span v-else>审核进行中，等待时间较长，可继续等待，或稍后去管理中心查看审核记录</span>
                            </div>
                        </div>
                        <div v-else-if="resultInfo.auditStatus === 2" style="margin-top: 150px; font-size: 27px; color: limegreen;">
                            审核通过，资源正常
                        </div>
                        <el-tabs v-if="resultInfo.auditStatus === 3" type="border-card" class="audit-result">
                            <el-tab-pane v-for="typeItem in resultInfo.errorList" :label="typeItem.type" :key="typeItem.type">
                                <!-- 关键词、文本、审核物料、缩略图 -->
                                <el-table border :data="typeItem.data">
                                    <template v-if="typeItem.type === '错别字'">
                                        <el-table-column prop="word" label="错别字" width="120"></el-table-column>
                                        <el-table-column prop="trueword" label="建议修改" width="120"></el-table-column>
                                        <el-table-column prop="text" label="所在文本"></el-table-column>
                                    </template>
                                    <template v-else-if="typeItem.type === '敏感词'">
                                        <el-table-column prop="word" label="敏感词" width="120"></el-table-column>
                                        <el-table-column prop="senstype" label="敏感词类型" width="120"></el-table-column>
                                        <el-table-column prop="text" label="所在文本"></el-table-column>
                                    </template>
                                    <template v-else-if="typeItem.type === '禁用词'">
                                        <el-table-column prop="word" label="禁用词" width="120"></el-table-column>
                                        <el-table-column prop="text" label="所在文本"></el-table-column>
                                    </template>
                                    <template v-else-if="typeItem.type === '疑似错别字'">
                                        <el-table-column prop="word" label="疑似错别字" width="120"></el-table-column>
                                        <el-table-column prop="trueword" label="建议修改" width="120"></el-table-column>
                                        <el-table-column prop="text" label="所在文本"></el-table-column>
                                    </template>
                                    <template v-else>
                                        <el-table-column prop="errType" label="问题类型" width="120"></el-table-column>
                                        <el-table-column prop="keyword" label="关键词" width="120"></el-table-column>
                                        <el-table-column prop="text" label="文本"></el-table-column>
                                        <el-table-column prop="timeInSeconds" label="所在位置" width="180" align="center" v-if="resType === 2 || resType === 3">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.multi === true">{{ scope.row.timeInSeconds }} - {{ scope.row.endSeconds }}</span>
                                                <span v-else>{{ scope.row.timeInSeconds }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="thumbnail" label="缩略图" width="200" v-if="resType !== 3">
                                            <template slot-scope="scope">
                                                <img class="err-thumbnail" :src="scope.row.thumbnail" alt="" height="100px" @click="zoomImg(scope.row.thumbnail)">
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>
                            </el-tab-pane>
                        </el-tabs>
                        <el-dialog :visible.sync="zoomImgDlg.show" width="700px">
                            <div>
                                <img :src="zoomImgDlg.image" alt="" style="max-width: 90%; max-height: 90%;">
                            </div>
                            <div slot="footer"></div>
                        </el-dialog>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div>
            <el-button @click="$router.push({ path: '/home' })">返回文本审核</el-button>
            <el-button @click="$router.push({ name: 'home', params: { type: 'webpage' } })">网页审核</el-button>
            <el-button @click="goResAuditPage(1)" v-if="this.resType !== 1">图片审核</el-button>
            <el-button @click="goResAuditPage(2)" v-if="this.resType !== 2">视频审核</el-button>
            <el-button @click="goResAuditPage(3)" v-if="this.resType !== 3">音频审核</el-button>
            <el-button v-if="showpage === 'result'" @click="goResAuditPage(resType)" style="background-color: cornflowerblue; color: white;">继续输入</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            resLink: '',
            showpage: 'input',
            fileUploadLoading: false,
            resultInfo: {
                link: '',
                auditStatus: 0, // 0-正在提交审核  1-审核中  2-审核完成，没问题  3-审核完成，有问题
                errorList: [],
                resultCheckTimes: 0
            },
            zoomImgDlg: {
                show: false,
                image: ''
            }
        }
    },
    methods: {
        goResAuditPage (ntype) {
            this.showpage = 'input'; 
            this.resLink = ''
            this.resultInfo.link = '';
            this.resultInfo.auditStatus = 0;
            this.resultInfo.errorList = [];

            console.log('curr:', this.resType, ' go:', ntype)
            if (ntype !== this.resType) {
                console.log('跳转审核类型')
                this.$router.push({ path: '/media', query: { type: ntype } }).catch(() => {});
            }
        },
        btnUploadFile (params) {
            const fileExt = params.file.name.substring(params.file.name.lastIndexOf('.') + 1).toLowerCase()
            console.log('文件大小：', params.file.size / 1024 / 1024)
            if (this.resType === 1) {
                if (params.file.size / 1024 / 1024 > 8) {
                    this.$message({ type: 'warning', message: '最大支持8M，请检查图片大小' })
                    return false
                }
                if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].indexOf(fileExt) === -1) {
                    this.$message({ type: 'warning', message: '不支持的文件类型' })
                    return false
                }
            }
            else if (this.resType === 2) {
                if (params.file.size / 1024 / 1024 > 100) {
                    this.$message({ type: 'warning', message: '最大支持100M，请检查视频大小' })
                    return false
                }
                if (['avi', 'mov', 'mp4', '3gp', 'rmvb', 'wmv', 'flv', 'm3u8'].indexOf(fileExt) === -1) {
                    this.$message({ type: 'warning', message: '不支持的文件类型' })
                    return false
                }
            }
            else if (this.resType === 3) {
                if (params.file.size / 1024 / 1024 > 20) {
                    this.$message({ type: 'warning', message: '最大支持20M，请检查音频大小' })
                    return false
                }
                if(['mp3','wav', 'wma'].indexOf(fileExt) === -1) {
                    this.$message({ type: 'warning', message: '不支持的音频类型' })
                    return false
                }
            }
            // 提交上传
            this.fileUploadLoading = true
            let formData = new FormData(); formData.append('file', params.file)
            this.$axios({
                url: '/cmsMateService/servlet/UploadFile',
                method: 'post',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' }
            }).then(res => {
                this.fileUploadLoading = false
                if (res.status !== 200 || parseInt(res.data.result) !== 200) {
                    this.$message({ type: 'warning', message: '上传失败' })
                } else {
                    var resLink = res.data.info.filePath
                    this.resLink = resLink
                    this.btnRunLinkAudit()
                }
            }).catch(() => {
                this.fileUploadLoading = false
                this.$message({ type: 'warning', message: '上传异常' })
            })
        },
        btnRunLinkAudit () {
            if (this.resLink.length <= 0) {
                this.$message({ type: 'warning', message: '请先输入资源链接' })
                return
            }
            this.resultInfo.auditStatus = 0
            this.showpage = 'result'
            this.resultInfo.link = this.resLink
            this.resultInfo.resultCheckTimes = 0
            // 开始提交审核
            this.resultInfo.errorList = []
            this.$axios.post('/cmsMateService/login.do?method=aiCheck', {
                username: sessionStorage.getItem('username'),
                path: this.resLink
            }).then(res => {
                if (res.status !== 200) {
                    this.$message({ type: 'warning', message: '提交审核异常' })
                } else if (parseInt(res.data.result) !== 200) {
                    this.$message({ type: 'warning', message: '提交审核失败：' + res.data.message })
                    if (res.data.message.indexOf('重新登录') != -1 || res.data.message.indexOf('参数缺失') != -1) {
                        setTimeout(() => {
                            window.sessionStorage.clear();
                            window.localStorage.clear();
                            this.$router.push({ path: "/login" });
                        }, 1000);
                    }
                    this.goResAuditPage(this.resType)
                } else {
                    this.$message({ type: 'success', message: '已提交审核，等待审核结果' })
                    var auditId = res.data.uuid
                    // 开始检查获取审核结果
                    this.getAuditResult(auditId)
                }
            }).catch(() => {
                this.$message({ type: 'warning', message: '提交审核异常' })
            })
        },
        getAuditResult (auditId) {
            this.resultInfo.resultCheckTimes += 1   // 统计审核等待时长
            this.resultInfo.auditStatus = 1
            this.$axios.post('/cmsMateService/login.do?method=achieveAiCheckResultList', {
                username: sessionStorage.getItem('username'),
                uuid: auditId
            }).then(res => {
                if (res.status !== 200) {
                    this.$message({ type: 'warning', message: '审核结果获取异常' })
                } else if (parseInt(res.data.result) !== 200) {
                    console.log('暂无审核结果记录')
                    setTimeout(() => { this.getAuditResult(auditId) }, 2000)
                } else {
                    // 成功获取到审核结果
                    var auditResult = res.data.info
                    // 结果映射到resultInfo.errorList
                    if (auditResult.status === 'ERROR') {
                        this.$message({ type: 'warning', message: '审核失败' })
                    } else if (auditResult.status !== 'FINISHED') {
                        // 排队中、审核中，还需要等待
                        console.log('资源审核中')
                        setTimeout(() => { this.getAuditResult(auditId) }, 2000)
                    } else {
                        this.$message({ type: 'success', message: '审核完成' })
                        // 审核完成
                        if (auditResult.label === '违规') {
                            this.resultInfo.auditStatus = 3
                            this.resultInfo.errorList = this.getFormatResult(auditResult.list, this.resType === 2)
                        } else {
                            this.resultInfo.auditStatus = 2
                        }
                    }
                }
            }).catch(() => {
                //
            })
        },
        zoomImg(imgUrl) {
            this.zoomImgDlg.show = true
            this.zoomImgDlg.image = imgUrl
        },
        getFormatResult (resultList, isVideo) {
            var fmResults = []
            for (var errIdx in resultList) {
                var errItem = resultList[errIdx]
                console.log('处理结果:', errIdx, errItem)
                var typeExist = false;

                if (errItem.scenes === '文本') {
                    for (var i = 0; i < fmResults.length; i++) {
                        if (fmResults[i].type === errItem.subType) {
                            fmResults[i].data.push({
                                word: errItem.word,
                                trueword: errItem.trueword ? errItem.trueword : '',
                                text: errItem.text,
                                senstype: errItem.senstype ? errItem.senstype : ''
                            })
                            typeExist = true; break
                        }
                    }
                    if (!typeExist) {
                        fmResults.push({ type: errItem.subType, data: [] })
                        fmResults[fmResults.length - 1].data.push({
                            word: errItem.word,
                            trueword: errItem.trueword ? errItem.trueword : '',
                            text: errItem.text,
                            senstype: errItem.senstype ? errItem.senstype : ''
                        })
                    }
                } else {
                    for (var i = 0; i < fmResults.length; i++) {
                        if (fmResults[i].type === errItem.scenes) {    // 类型已存在，直接在类型下写入错误结果
                            typeExist = true
                            var typeLastErrIdx = fmResults[i].data.length - 1
                            var typeLastErr = fmResults[i].data[typeLastErrIdx]
                            if (isVideo && errItem.subType === typeLastErr.errType && errItem.extra === typeLastErr.keyword && errItem.text === typeLastErr.text) {
                                if (typeLastErr.endSeconds !== errItem.timeInSeconds) {
                                    fmResults[i].data[typeLastErrIdx].multi = true
                                    fmResults[i].data[typeLastErrIdx].endSeconds = errItem.timeInSeconds
                                }
                            } else {
                                fmResults[i].data.push({
                                    errType: errItem.subType,
                                    keyword: errItem.extra,
                                    text: errItem.text,
                                    thumbnail: errItem.thumbnail,
                                    timeInSeconds: ((isVideo || this.resType === 3) ? errItem.timeInSeconds : 0),
                                    endSeconds: ((isVideo || this.resType === 3) ? errItem.timeInSeconds : 0),
                                    multi: false
                                })
                            }
                            break
                        }
                    }
                    if (!typeExist) {
                        fmResults.push({ type: errItem.scenes, data: [] })
                        fmResults[fmResults.length - 1].data.push({
                            errType: errItem.subType,
                            keyword: errItem.extra,
                            text: errItem.text,
                            thumbnail: errItem.thumbnail,
                            timeInSeconds: ((isVideo || this.resType === 3) ? errItem.timeInSeconds : 0),
                            endSeconds: ((isVideo || this.resType === 3) ? errItem.timeInSeconds : 0),
                            multi: false
                        })
                    }
                }
            }
            return fmResults
        }
    },
    computed: {
        resType () { return parseInt(this.$route.query.type) },
        resTypeName () {
            if (parseInt(this.$route.query.type) === 1) return '图片审核'
            else return '视频审核'
        },
        uploadAcceptType () {
            if (this.resType === 1) return '.jpg,.jpeg,.png,.gif,.bmp,.webp'
            else if (this.resType === 2) return '.avi,.mov,.mp4,.3gp,.rmvb,.wmv,.flv,.m3u8'
            else if (this.resType === 3) return '.mp3,.wav,.wma'
            else return ''
        },
        linkInputPlaceholder () {
            if (this.resType === 1) return '请输入图片的网络访问地址'
            else if (this.resType === 2) return '请输入视频的网络访问地址'
            else if (this.resType === 3) return '请输入音频的网络访问地址'
            else return ''
        }
    },
    mounted () {
        this.showpage = 'input'; 
        this.resultInfo.link = '';
        this.resultInfo.auditStatus = 0;
        this.resultInfo.errorList = [];

        var userType = parseInt(sessionStorage.getItem('status'))
        if (userType !== 0 && userType !== 3) {
            this.$message.warning('没有权限')
            // this.$router.push({ path: '/home' })
            this.$router.go(-1)
        }
    }
}
</script>

<style>
.err-thumbnail :hover {
    transform: scale(1.4);
}
.audit-result > .el-tabs--border-card > .el-tabs__content {
    position: absolute;
    top: 125px;
    bottom: 0px;
    left: 30px;
    right: 30px;
    overflow-y: auto;
}
.loader {
  margin: 150px auto 40px;
}
.loader--spinningDisc {
  border: solid 0.5em #9b59b6;
  border-right-color: transparent;
  border-left-color: transparent;
  padding: 0.5em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #3498db;
  background-clip: content-box;
  animation: spinDisc 1.5s linear infinite;
}
@keyframes spinDisc {
  50% {
    border-top-color: #3498db;
    border-bottom-color: #3498db;
    background-color: #2ecc71;
  }
  100% {
    transform: rotate(1turn);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/MediaAudit.vue